import { render, staticRenderFns } from "./SquishyThumbToken.vue?vue&type=template&id=e4ea19ca&lang=pug&"
import script from "./SquishyThumbToken.vue?vue&type=script&lang=js&"
export * from "./SquishyThumbToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports